import { useMutation, useQuery } from '@tanstack/react-query';
import api from './config';

// Add card to binder
export const useAddCardToBinder = () => {
  return useMutation({
    mutationFn: async ({ card_id, quantity = 1 }) => {
      const response = await api.post('/cards/binder/add_card/', {
        card_id,
        quantity,
      });
      return response.data;
    },
  });
};

// Remove card from binder
export const useRemoveCardFromBinder = () => {
  return useMutation({
    mutationFn: async ({ card_id, quantity = 1 }) => {
      const response = await api.post('/cards/binder/remove_card/', {
        card_id,
        quantity,
      });
      return response.data;
    },
  });
}; 

// Fetch owned cards for a given username
export const useOwnedCards = (username) => {
  return useQuery({
    queryKey: ['ownedCards', username],
    queryFn: async () => {
      const response = await api.get(`/cards/binder/owned_cards/?username=${encodeURIComponent(username)}`);
      return response.data;
    },
    enabled: !!username,
  });
};

// Create a new deck
export const useCreateDeck = () => {
  return useMutation({
    mutationFn: async ({ name, deck_type, description, selected_cards }) => {
      const response = await api.post('/cards/decks/', {
        name,
        deck_type,
        description,
        selected_cards,
      });
      return response.data;
    },
  });
};

// Fetch decks with optional filters
export const useDecks = (filters = {}) => {
  return useQuery({
    queryKey: ['decks', filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters.deck_type) params.append('deck_type', filters.deck_type);
      if (filters.search) params.append('search', filters.search);
      if(params.toString().length > 0) {
        const response = await api.get(`/cards/decks/?${params.toString()}`);
        return response.data;
      } else {
        const response = await api.get('/cards/decks/');
        return response.data;
      }
    },
  });
};

export const useDeleteDeck = () => {
  return useMutation({
    mutationFn: async (deckId) => {
      const response = await api.delete(`/cards/decks/${deckId}/`);
      return response.data;
    },
  })
}